export default {"src":"/_next/static/image/public/images/ic_trash_grey.3913458f863b8580967674e9a8ca6cb2.svg","height":20,"width":18};